import getCookie from "@utilities/getCookie";
import React, { useContext, useEffect, useState } from "react";
import { UserContext } from "../../context/user";
import { getProfileContactPreferences } from "../../services/forms";
import styles from "./RadioButtons.module.scss";
import clsx from "clsx";

export interface OptionsProps {
  id: string;
  label: any;
  val: boolean;
}
export interface RadioButtonsProps {
  register: any;
  formState: {
    errors: object;
  };
  options: {
    name: string;
    options: OptionsProps[];
  };
  className?: string;
}

const RadioButtons = (props: RadioButtonsProps) => {
  const { register, options, formState, className } = props;

  const { user } = useContext(UserContext);
  const [preferences, setPreferences] = useState<any>(null);

  useEffect(() => {
    const getPreferences = async () => {
      if (user) {
        try {
          const emailSubscriptions = await getProfileContactPreferences(
            getCookie("access_token")
          );
          setPreferences(emailSubscriptions?.result?.canContactByEmail);
        } catch (e) {
          console.log(e);
        }
      }
    };
    getPreferences();
  }, [user]);

  const hasError = Boolean(formState?.errors?.[options.name]);
  const describedById = hasError ? `${options.name}-message` : undefined;

  return (
    <div
      className={clsx(styles["radio-buttons"], className)}
      role="radiogroup"
      aria-invalid={hasError ? "true" : undefined}
    >
      {options?.options?.map(({ id, label, val }) => (
        <React.Fragment key={`${id}-${label}`}>
          <input
            type="radio"
            id={id}
            name={options.name}
            onClick={() => {
              setPreferences(val);
            }}
            checked={preferences === val}
            value={val}
            aria-describedby={describedById}
            {...register(options.name, {
              required: "This field is required",
            })}
          />
          <label htmlFor={id}>{label}</label>
        </React.Fragment>
      ))}
      {hasError && (
        <div className={styles.error} id={`${options.name}-message`}>
          <p>
            <span className="sr-only">Error:</span> Please choose an option
          </p>
        </div>
      )}
    </div>
  );
};

export default RadioButtons;
